import { useFormikContext } from "formik";
import { OnboardingFormValues } from "../Onboarding";
import Alias from "@/components/Alias";
import { useMemo } from "react";
import isEmpty from "lodash/isEmpty";
import { useResponsive } from "@/hooks";

const OrganizationAliasStep = () => {
  const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();
  const { isExtraSmall } = useResponsive();

  const handleChange = (value: string) => {
    setFieldValue("alias", value);
  };

  const alias = useMemo(() => {
    if (!isEmpty(values?.alias)) {
      return values.alias;
    }
    if (!isEmpty(values?.title)) {
      return values.title;
    }
    return "";
  }, [values]);

  return (
    <Alias
      value={alias}
      onChange={handleChange}
      onSuccess={() => setFieldValue("isAliasValid", true)}
      onFail={() => setFieldValue("isAliasValid", false)}
      sx={{
        ".field-container": {
          color: "white",
          border: "2px solid rgba(255,255,255, 0.25)",
          ...(isExtraSmall
            ? {
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              borderBottom: "none",
            }
            : {
              borderTopLeftRadius: 12,
              borderBottomLeftRadius: 12,
              borderRight: "none",
            }),
        },
        ".alias-input .MuiOutlinedInput-root": {
          backgroundColor: "transparent",
          color: "white",
          border: "2px solid rgba(255,255,255, 0.25)",
          ...(isExtraSmall
            ? {
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }
            : {
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
            }),
        },
      }}
    />
  );
};

export default OrganizationAliasStep;
